<template>
  <div v-if="isAuthenticated" class="container-fluid shadow bb-page-title-bg d-flex">
    <!---------------------------------->
    <!-- character sheet adjustments   -->
    <!----------------------------------->
    <p v-if="getCurrentView == 'character_adjustments'" class="bb-page-title my-auto px-4">
      Character Sheet adjustments
    </p>
    <!--------------------------------------------->
    <!-- character sheet adjustments (applied)   -->
    <!--------------------------------------------->
    <p v-if="getCurrentView == 'character_adjustments_applied'" class="bb-page-title my-auto px-4">
      Character Sheet Adjustments (Applied)
    </p>
    <!--------------------------------------------->
    <!-- character sheet adjustments (optional)   -->
    <!--------------------------------------------->
    <p v-if="getCurrentView == 'character_adjustments_optional'" class="bb-page-title my-auto px-4">
      Character Sheet Adjustments (Optional)
    </p>
    <!----------------------------->
    <!-- character sheet view    -->
    <!----------------------------->
    <p v-if="getCurrentView == 'character_sheets'" class="bb-page-title my-auto px-4">
      Character Sheet
    </p>
    <!------------------------------------>
    <!-- all non-character sheet views  -->
    <!------------------------------------>
    <p v-if="getCurrentView != 'character_sheets' && getCurrentView != 'character_adjustments_applied' && getCurrentView != 'character_adjustments_optional' && getCurrentView != 'character_adjustments'"
      class="bb-page-title my-auto px-4">
      {{ getPageTitle }}
    </p>
    <!----------------------------------->
    <!-- add campaign suffix to title  -->
    <!----------------------------------->
    <p v-if="getCurrentView == 'dm_combat' || getCurrentView == 'campaign_artefacts'" class="bb-page-arena-name my-auto px-3">
      {{ campaignName }}
    </p>
    <!------------------------------------>
    <!-- add character suffix to title  -->
    <!------------------------------------>
    <p v-if="getCurrentView == 'character_sheets' || getCurrentView == 'character_adjustments_applied' || getCurrentView == 'character_adjustments_optional'"
      class="bb-page-arena-name my-auto px-3 capitalize">
      {{ char_name }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PageHeader",
  //---------
  // methods
  //---------
  computed: {
    ...mapGetters("auth", {
      getPageTitle: "getPageTitle",
      isAuthenticated: "isAuthenticated",
      getCurrentView: "getCurrentView",
    }),
    ...mapGetters("combat", {
      campaignName: "getCampaignName",
    }),
    ...mapGetters("characters", {
      getCurrentCharacter: "getCurrentCharacter",
    }),
    char_name() {
      return this.getCurrentCharacter ? this.getCurrentCharacter.name : "";
    },
  },
};
</script>